export default __webpack_public_path__ + "static/media/Deshbandhu.940ff343.jpg";